<div mat-dialog-title>
  <fa-icon icon="times" (click)="onClick(false)" id="fdm-dialog-close" class="fdm-icon float-right"></fa-icon>
  {{data.title | translate }}
</div>

<div mat-dialog-content *ngIf="data.apis">
   <div *ngIf="data.apis.length > 1">

    <div><b translate>API.SELECT</b></div>
    <div>
        <button mat-raised-button class="mr-1" [color]="cur == curApi?'primary':''" (click)="curApi = cur" *ngFor="let cur of data.apis">
            {{ cur.name }}
        </button>
    </div>
   </div>

   <div *ngIf="data.askDatasetName">
    <mat-form-field class="full-width">
      <input matInput #datasetName type="text" name="datasetName"
             [(ngModel)]="data.datasetName" required
             placeholder="{{ 'API.DATASET_NAME' | translate }}">
    </mat-form-field>
  </div>

  <div translate *ngIf="data.aboutToProcess">
    API.READY
  </div>

   <div *ngIf="curApi.qMap" class="mt-2">
      <div ><b translate>API.NEEDS_PARAM</b></div>

      <div *ngFor="let cur of curApi.qMap" qmap-question [qMap]="cur" [model]="data.model">
      </div>
   </div>
</div>

<div mat-dialog-actions class="align-content-right" style="margin-bottom:inherit!important">

  <button mat-stroked-button  (click)="onClick(false)">{{ 'GENERIC.CANCEL' | translate }}</button>

  <button mat-flat-button color="primary" [disabled]="data.askDatasetName && data.datasetName.length === 0" (click)="ok()">{{ 'API.START' | translate }}</button>

  <!--<button mat-raised-button class="mr-1" [color]="primary" (click)="ok(true)" *ngIf="!data.isFullProcessing">
    ByPass Preview
  </button>-->
</div>
